import Interceptor from "./Interceptor";

/**
 * External Migration Service
 * Handles importing WordPress sites from external hosts via the WP Spark Migrate plugin
 */

/**
 * Generate a one-time migration token
 * @param {object} data - Optional label
 */
export const generateMigrationToken = async (data = {}) => {
  const response = await Interceptor.post("/external-migrations/token", data);
  return response.data;
};

/**
 * List migration tokens
 */
export const listMigrationTokens = async () => {
  const response = await Interceptor.get("/external-migrations/tokens");
  return response.data;
};

/**
 * Revoke a migration token
 * @param {string} tokenId
 */
export const revokeMigrationToken = async (tokenId) => {
  const response = await Interceptor.delete(
    `/external-migrations/tokens/${tokenId}`,
  );
  return response.data;
};

/**
 * List external migrations
 * @param {object} params - Query params (page, limit, status)
 */
export const listExternalMigrations = async (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  const response = await Interceptor.get(`/external-migrations?${queryParams}`);
  return response.data;
};

/**
 * Get external migration details
 * @param {string} migrationId
 */
export const getExternalMigration = async (migrationId) => {
  const response = await Interceptor.get(`/external-migrations/${migrationId}`);
  return response.data;
};

/**
 * Retry a failed external migration
 * @param {string} migrationId
 */
export const retryExternalMigration = async (migrationId) => {
  const response = await Interceptor.post(
    `/external-migrations/${migrationId}/retry`,
  );
  return response.data;
};

/**
 * Delete a migration and cleanup its resources
 * @param {string} migrationId
 */
export const deleteExternalMigration = async (migrationId) => {
  const response = await Interceptor.delete(
    `/external-migrations/${migrationId}`,
  );
  return response.data;
};
